import { LogOutIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { supabase } from '../../../shared/api/supabase';
import { DropdownMenuItem } from '../../../shared/ui/dropdown-menu';

/** "Sign out" entry for the user menu. The session listener redirects once Supabase signs out. */
export function SignOutMenuItem() {
  const { t } = useTranslation('auth');
  return (
    <DropdownMenuItem onSelect={() => void supabase.auth.signOut()}>
      <LogOutIcon aria-hidden="true" />
      {t('signOut')}
    </DropdownMenuItem>
  );
}
